<template>
  <form
    class="donate"
    v-if="procedure && block.isShowed('donate_field')"
  >
    <label
      class="donate__label bold"
      for="amount"
      v-if="block.isShowed('text_donate_field')"
    >
      {{ label }}
    </label>

    <input-amount
      class="donate__input"
      id="amount"
      v-model="formAmount"
    />

    <project-button
      class="btn__size--full-6 donate__button margin__t--12"
      :project="project"
      :is-preview="is_preview"
      v-if="labelButton"
    >
      {{ labelButton }}
    </project-button>
  </form>
</template>

<script setup>
import { computed, defineAsyncComponent, inject } from 'vue'
import { useI18n } from '@/vendors/i18n'
import { useProcedureExecutionStore } from '@/stores/ProcedureExecutionStore'
import { useProcedure, useProcedureTransaction } from '@/composables/modules/procedures'
import { get as _get } from 'lodash'

import InputAmount from '&/atoms/InputAmount'
const ProjectButton = defineAsyncComponent(() => import('@/components/modules/project/ProjectButton'))

const { block } = defineProps({
  column: { type: Object, required: true },
  block: { type: Object, required: true }
})

const { translate } = useI18n()
const { getProcedureExecution } = useProcedureExecutionStore()

const objects = inject('objects', {})
const is_preview = inject('preview', false)

const project = computed(() => _get(objects.value, 'project'))
const procedure = computed(() => project.value?.donation_procedure)
const label = computed(() => translate(block.getText('donate_field')))
const labelButton = computed(() => translate(block.getText('donate_button')))

const { id } = useProcedure({ procedure })
const { procedureExecution } = getProcedureExecution({ procedure_id: id })
const { formAmount } = useProcedureTransaction({ procedure, procedure_execution: procedureExecution })
</script>

<style lang="scss" scoped>
.donate {
  border: 1px solid rgba(#2E293D, .1);
  border-radius: 4px;
  padding: 18px;

  &__input {
    background: transparent;
  }

  &__label {
    display: block;
    margin-bottom: 12px;
    font-weight: bold;
  }
}
</style>
